import styled from '@emotion/styled/macro'

const ActionsContainer = styled('div')`
  display: flex;
  flex-direction: column;

  > a:last-of-type:not(:only-of-type) {
    margin-top: 6px;
  }
`

export { ActionsContainer }
